import "./AddResult.css";
import React, { Fragment } from "react";
import AddResultViewModel from "./AddResultViewModel";
import { PulseLoader } from "react-spinners";

const AddResult = () => {
  const {
    RegisterResult,
    StudentsMarks,
    setStudentsMarks,
    StudentsArray,
    FormDisabled,
    IsLoading,
    ObtainedMarksError,
    ExamData,
    ExamType,
    CourseName,
  } = AddResultViewModel();

  return (
    <Fragment>
      {/* Page Wrapper */}
      <div className="page-wrapper admin-add-result-page">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Add Result</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="#">Dashboard</a>
                  </li>
                  <li className="breadcrumb-item active">Add Result</li>
                </ul>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          <div className="student-group-form">
            <div className="row">
              <div className="col-lg-3 col-md-6">
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search by ID ..."
                  />
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search by Name ..."
                  />
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search by Year ..."
                  />
                </div>
              </div>
              <div className="col-lg-2">
                <div className="search-student-btn">
                  <button type="btn" className="btn btn-primary">
                    Search
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table">
                <div className="card-body">
                  {/* Page Header */}
                  <div className="page-header">
                    <div className="row align-items-center">
                      <div className="col">
                        <h3 className="page-title">Add Result</h3>
                      </div>
                    </div>
                  </div>
                  {/* /Page Header */}
                  {IsLoading ? (
                    <PulseLoader
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      color="#3D5EE1"
                      size={16}
                    />
                  ) : (
                    <div className="table-responsive">
                      <table className="table border-0 star-student table-hover table-center mb-0 datatable table-striped">
                        <thead className="student-thread">
                          <tr>
                            <th>Name</th>
                            <th>Registration No</th>
                            <th>Exam Type</th>
                            <th>Subject</th>
                            <th>Gender</th>
                            <th>Total Marks</th>
                            <th className="text-end">Marks Obtained</th>
                          </tr>
                        </thead>
                        <tbody>
                          {StudentsArray &&
                            StudentsArray.map((item, index) => {
                              // First Name Start
                              const ArrayOfFirstNameWords =
                                item?.FirstName.split(" ");
                              for (
                                var i = 0;
                                i < ArrayOfFirstNameWords.length;
                                i++
                              ) {
                                ArrayOfFirstNameWords[i] =
                                  ArrayOfFirstNameWords[i]
                                    .charAt(0)
                                    .toUpperCase() +
                                  ArrayOfFirstNameWords[i].slice(1);
                              }
                              const StringOfFirstNameWords =
                                ArrayOfFirstNameWords.join(" ");
                              // First Name End

                              // Last Name Start
                              const ArrayOfLastNameWords =
                                item?.LastName.split(" ");
                              for (
                                var j = 0;
                                j < ArrayOfLastNameWords.length;
                                j++
                              ) {
                                ArrayOfLastNameWords[j] =
                                  ArrayOfLastNameWords[j]
                                    .charAt(0)
                                    .toUpperCase() +
                                  ArrayOfLastNameWords[j].slice(1);
                              }
                              const StringOfLastNameWords =
                                ArrayOfLastNameWords.join(" ");
                              // Last Name End
                              return (
                                <tr key={index}>
                                  <td>
                                    {StringOfFirstNameWords +
                                      " " +
                                      StringOfLastNameWords}
                                  </td>
                                  <td>
                                    {
                                      item?.AdditionalDetails
                                        ?.StudentRegistrationNo
                                    }
                                  </td>
                                  <td>{ExamType}</td>
                                  <td>{CourseName}</td>
                                  <td className="text-capitalize">
                                    {item?.Gender}
                                  </td>
                                  <td>{ExamData?.ExamTotalMarks}</td>
                                  <td className="text-end">
                                    <div className="actions">
                                      <div className="col-12 col-sm-6">
                                        <div className="form-group">
                                          <input
                                            type="text"
                                            className="form-control"
                                            // className={`form-control ${
                                            //   ObtainedMarksError === true &&
                                            //   "error-message"
                                            // }`}
                                            onBlur={(e) => {
                                              if (e.target.value !== "") {
                                                let isContain = false;
                                                StudentsMarks.map(
                                                  (elem, index) => {
                                                    if (elem.id === item.id) {
                                                      isContain = true;

                                                      StudentsMarks[
                                                        index
                                                      ].ObtainedMarks =
                                                        e.target.value;
                                                      setStudentsMarks(
                                                        StudentsMarks
                                                      );
                                                    }
                                                  }
                                                );

                                                if (isContain === false) {
                                                  setStudentsMarks([
                                                    ...StudentsMarks,
                                                    {
                                                      ObtainedMarks:
                                                        e.target.value,
                                                      id: item.id,
                                                    },
                                                  ]);
                                                }
                                              }
                                            }}
                                            disabled={FormDisabled}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>

                {ObtainedMarksError === true && (
                  <span className="error-message-text">
                    One or more fields are empty
                  </span>
                )}
                <div className="col-auto text-end float-end ms-auto download-grp submit-btn-container">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => {
                      RegisterResult();
                    }}
                    disabled={FormDisabled}
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
    </Fragment>
  );
};

export default AddResult;
